import {
  REF_MARKER_CROWSFOOT_DECLARED,
  REF_MARKER_CROWSFOOT_INFERRED,
  REF_MARKER_ONE_DECLARED,
  REF_MARKER_ONE_INFERRED,
} from "../utils";

const DECLARED_COLOR = "#6B7280";
const INFERRED_COLOR = "#8B5CF6";
const STROKE_WIDTH = "2.6";

// Crow's-foot path: three lines fanning from a single apex at (1, 7) out
// to the wide end at x=14. With refX=14 the wide end anchors at the line
// tip (= node border), apex points back along the line.
const CROWSFOOT_PATH = "M 14 1 L 1 7 M 14 7 L 1 7 M 14 13 L 1 7";
// Bar path: single perpendicular tick at x=4.
const BAR_PATH = "M 4 1 L 4 13";

/**
 * Marker definitions for ERD overlay edges. Rendered as a zero-sized
 * absolutely-positioned `<svg>` so the marker IDs are resolvable via
 * `url(#…)` from React Flow's edge SVG (same-document fragment refs).
 *
 * Two shapes × two colors = four markers:
 *   - Crow's-foot ("many" side) in declared-grey or inferred-indigo
 *   - Bar ("one" side) in declared-grey or inferred-indigo
 *
 * `createRefEdge` picks per-end markers based on `ref.cardinality`:
 *   many-to-one  → cf at FK end, bar at PK end (typical FK)
 *   one-to-one   → bar at both ends
 *   one-to-many  → bar at FK end, cf at PK end (rare)
 *   many-to-many → cf at both ends (rare)
 *
 * `markerUnits="userSpaceOnUse"` keeps marker pixel-sizes constant
 * regardless of edge stroke width or zoom.
 */
export const RefEdgeMarkers = () => (
  <svg
    aria-hidden
    style={{ position: "absolute", width: 0, height: 0, pointerEvents: "none" }}
    focusable="false"
  >
    <defs>
      <marker
        id={REF_MARKER_CROWSFOOT_DECLARED}
        viewBox="0 0 16 14"
        refX="14"
        refY="7"
        markerWidth="16"
        markerHeight="14"
        orient="auto-start-reverse"
        markerUnits="userSpaceOnUse"
      >
        <path
          d={CROWSFOOT_PATH}
          fill="none"
          stroke={DECLARED_COLOR}
          strokeWidth={STROKE_WIDTH}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </marker>
      <marker
        id={REF_MARKER_CROWSFOOT_INFERRED}
        viewBox="0 0 16 14"
        refX="14"
        refY="7"
        markerWidth="16"
        markerHeight="14"
        orient="auto-start-reverse"
        markerUnits="userSpaceOnUse"
      >
        <path
          d={CROWSFOOT_PATH}
          fill="none"
          stroke={INFERRED_COLOR}
          strokeWidth={STROKE_WIDTH}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </marker>
      <marker
        id={REF_MARKER_ONE_DECLARED}
        viewBox="0 0 8 14"
        refX="6"
        refY="7"
        markerWidth="8"
        markerHeight="14"
        orient="auto-start-reverse"
        markerUnits="userSpaceOnUse"
      >
        <path
          d={BAR_PATH}
          fill="none"
          stroke={DECLARED_COLOR}
          strokeWidth={STROKE_WIDTH}
          strokeLinecap="round"
        />
      </marker>
      <marker
        id={REF_MARKER_ONE_INFERRED}
        viewBox="0 0 8 14"
        refX="6"
        refY="7"
        markerWidth="8"
        markerHeight="14"
        orient="auto-start-reverse"
        markerUnits="userSpaceOnUse"
      >
        <path
          d={BAR_PATH}
          fill="none"
          stroke={INFERRED_COLOR}
          strokeWidth={STROKE_WIDTH}
          strokeLinecap="round"
        />
      </marker>
    </defs>
  </svg>
);
